import { render, staticRenderFns } from "./TaxMapping.vue?vue&type=template&id=24a173f8&scoped=true&"
import script from "./TaxMapping.vue?vue&type=script&lang=js&"
export * from "./TaxMapping.vue?vue&type=script&lang=js&"
import style0 from "./TaxMapping.vue?vue&type=style&index=0&id=24a173f8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a173f8",
  null
  
)

export default component.exports